import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-esignature-modal',
  templateUrl: './esignature-modal.component.html',
  styleUrls: ['./esignature-modal.component.scss']
})
export class EsignatureModalComponent implements OnInit, OnDestroy {
  @Input() signingUrl!: string;
  private messageListener: any;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.messageListener = (event: MessageEvent) => {
      if (typeof event.data === 'string' && event.data.includes('esignature:completed')) {
        this.activeModal.close('signed');
      }
    };
    window.addEventListener('message', this.messageListener);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.messageListener);
  }
} 